/** Minimum assumed throughput (~0.5 Mbps) for slow 4G uploads. */
const UPLOAD_MIN_BYTES_PER_SECOND = 64 * 1024;
const UPLOAD_BASE_TIMEOUT_MS = 2 * 60 * 1000;
const UPLOAD_MAX_TIMEOUT_MS = 2 * 60 * 60 * 1000;

export const UPLOAD_MAX_ATTEMPTS = 3;

export function getUploadTimeoutMs(fileSizeBytes) {
  const size = Number(fileSizeBytes) || 0;
  const sizeBasedMs = (size / UPLOAD_MIN_BYTES_PER_SECOND) * 1000;
  return Math.min(UPLOAD_MAX_TIMEOUT_MS, Math.max(UPLOAD_BASE_TIMEOUT_MS, sizeBasedMs));
}
